import React, { Component } from 'react'

import Config from '../config/Config';
import WidgetAjax from './WidgetAjax';
import Cache from '../frame/Cache';

import WidgetTable from './WidgetTable';
import WidgetSelect from './WidgetSelect';
import WidgetTreePicker from './WidgetTreePicker';

import { Form } from 'antd';
import { Input } from 'rsuite';

import "../css/marketing.css"

class widgetMareting extends Component {

    constructor(props){
        super(props);

        let path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        this.state = {
            path,
            selectoptions:{
                cleanable : true,
            },
            userStatusData: [
                {label:'不限', value:'0'},
                {label:'工商关系', value:'1'},
                {label:'关联关系', value:'2'}
            ],
            groupData: [
                {label:'不限', value:'0'},
                {label:'极为推荐', value:'1'},
                {label:'较为推荐', value:'2'},
                {label:'不推荐', value:'3'}
            ],
            industryData:[
                {label:'不限', value:'0'},
                {label:'农业', value:'1'},
                {label:'工商业', value:'2'},
                {label:'金融机构', value:'3'}
            ],
            conditionData:[
                {label:'不限', value:'0'},
                {label:'预付费', value:'1'},
                {label:'后付费', value:'2'}
            ],
            state : undefined, 
            group : undefined, 
            industry:undefined,
            condition:undefined,
            departmentTreeoptions : {
                title:"",
                type : 'select'
            },
            keyWord : undefined,
            parentDepartmentData:[],
            titleData:[]
        }
        this.paramsChange=this.paramsChange.bind(this);
        this.parentDepartmentOnSelect=this.parentDepartmentOnSelect.bind(this);
        this.loadDepartmentInfo = this.loadDepartmentInfo.bind(this);
        this.onLoadDepartmentInfo = this.onLoadDepartmentInfo.bind(this);
        this.queryData=this.queryData.bind(this);
        this.buildDepartmentData = this.buildDepartmentData.bind(this);
        this.searchEvents = this.searchEvents.bind(this)
        this.onSearchEvents = this.onSearchEvents.bind(this)
        
    }

    componentDidMount()
    {
        this.loadDepartmentInfo();
        this.searchEvents()
        // this.groupSearch();
    }

    componentWillReceiveProps(nextProps)
    {
        if( this.state.keyWord != nextProps )
        {
            this.setState({
                keyWord:nextProps.enterpriseName
            });

            this.searchEvents(nextProps.enterpriseName)
        }
    }

    queryData()
    {   
        let filters = {};

        const { keyWord, typeValue, group, state, parentDepartmentId} = this.state;

        if( keyWord!==undefined && keyWord!=="" )
        {
            if( typeValue===1)
            {
                 filters["realname"] = "${realname} has '" + keyWord+"'";
            }  
        }

        if( group!==undefined && group!==""&& group!==null )
        {
            filters["groupId"] = "${groupId} = '"+group+"'";
        }
        else
        {
            filters["groupId"] = undefined;
        }

        if( state!==undefined && state!=="" && state!==null )
        {
            filters["state"] = "${state} = '"+state+"'";
        }
        else
        {
            filters["state"] = undefined;
        }

        if( parentDepartmentId!==undefined && parentDepartmentId!==""&& parentDepartmentId!==null )
        {
            filters["parentDepartmentId"] = "${parentDepartmentId} = '"+parentDepartmentId+"'";
        }

        else
        {
            filters["parentDepartmentId"] = undefined;
        }

        // this.sendEvent("set.report.filter", {schemaName:"T500001", filters:filters});
        this.setState({showType:1});
    }

    searchEvents( enterpriseName = undefined ){
        const { path } = this.state,
              params = {};

        if(enterpriseName)
        {
            params["ENTNAME"] = enterpriseName
        }
        
        WidgetAjax.ajax({url:path + 'entity/relation', params:params, callback:this.onSearchEvents});
    }

    onSearchEvents(result)
    {
        if (result.status === 0) 
        {
            console.log(result)
            // this.setState({titleData:result.results});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }
    
    loadDepartmentInfo()
    {
        const { path } = this.state;

        WidgetAjax.ajax({url:path + 'group/info', params:undefined, callback:this.onLoadDepartmentInfo});
    }

    onLoadDepartmentInfo(result, params )
    {
        console.log(result)
        if( result.status===0 )
        {
            let departmentData = this.buildDepartmentData(result.results, -1);

            this.setState({parentDepartmentData:departmentData});
        }
    }
    
    buildDepartmentData( data, parent)
    {
        let items = [];

        for( let i=0; i<data.length; i++ )
        {
            let node = {};
            
            node.role = parent;
            node.label = data[i].name;
            node.id = data[i].id;
            node.value = data[i].id;

            if( data[i].subdepartments !== undefined )
            {
                node.children = this.buildDepartmentData(data[i].subdepartments, data[i].id);
            }
            
            items.push(node);
        }

        return items;
    }


    /**
     * 上级部门选择
     * @param {*} values 
     */
     parentDepartmentOnSelect( values )
     {
         
         if(values.length === 0)
         {
             this.state["parentDepartmentId"] = undefined;
             return null;
         }
 
         if( values!==undefined && values.length ===1 )
         {
             this.state["parentDepartmentId"] = values[0];
         }
     }
 
    paramsChange(value,type)
    {
        switch( type )
        {
            case 'type':
            {
                this.setState({typeValue:value})
                // this.state["typeValue"] = value;
                break;
            }
            case 'state':
            {
                this.setState({state:value})
                // this.state["state"] = value;
                break;
            }
            case 'keyWord':
            {
                this.setState({keyWord:value})
                break;
            }
            case 'group':
            {
                this.setState({group:value})
                // this.state["group"] = value;
                break;
            }
            default:
                break;
        }
    }

    render() {
        let {selectoptions,userStatusData,state,groupData,group,departmentTreeoptions,
            keyWord,parentDepartmentData,parentDepartmentId, industryData,industry,conditionData,condition
       } = this.state;
       return (
            <div>
                <div className="marketing-content" style={{height:'auto', paddingBottom: 0}} >
                    <div className="content-canvas content-top-frame-height height-100 content-height" style={{borderRadius:"1px",boxShadow:"none"}}>
                        <div className="maretingSelectTime">
                            <div className="maretingSelectLog">
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="营销类型" className="aaa">
                                        <WidgetSelect options={selectoptions} data={userStatusData} onSelect={(value)=>this.paramsChange(value,'state')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="企业状态">
                                        <WidgetSelect options={selectoptions} data={conditionData} onSelect={(value)=>this.paramsChange(value,'condition')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                            </div>

                            <div className="maretingSelectLog"> 
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="推荐度" >
                                        <WidgetSelect options={selectoptions} data={groupData} onSelect={(value)=>this.paramsChange(value,'group')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div> 
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="行业类型">
                                        <WidgetSelect options={selectoptions} data={industryData} onSelect={(value)=>this.paramsChange(value,'industry')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                                
                            </div>
                            <div className="maretingSelectLog">
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="所在地区">
                                        <WidgetTreePicker options={departmentTreeoptions} data={parentDepartmentData} defaultValues={[parentDepartmentId]}
                                            onSelect={this.parentDepartmentOnSelect}></WidgetTreePicker>
                                    </Form.Item>
                                </div>

                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="合作企业">
                                        <div style={{width: '393px', margin:'5px -6px', float: 'right', borderRadius:"0px",paddingRight:"50px"}} >
                                            <Input onChange={(value) => {this.paramsChange(value, 'keyWord')}} placeholder="合作企业名称" value={keyWord}></Input>
                                        </div>
                                    </Form.Item>
                                </div>
                               
                            </div>
                            <div className="maretingSelectLog">
                                <div className='maretingSelectLog-item' style={this.props.flag?{display:"none"}:{display:"block"}}>
                                    <Form.Item label="输入企业">
                                        <div style={{width: '408px', margin:'5px -6px', float: 'right', borderRadius:"0px",paddingRight:"68px"}} >
                                            <Input onChange={(value) => {this.paramsChange(value, 'keyWord')}} placeholder="输入企业名称" value={keyWord}></Input>
                                        </div>
                                    </Form.Item>
                                </div>
                            </div>
                        </div> 
                        <div className="selectStates" style={{border:"none"}}>
                            <button className="querys click" onClick={this.queryData} >确定</button>
                            <button className="clears click" onClick={this.props.backMarKeting}>取消</button>
                        </div>
                    </div>
                </div>
                

            </div> 
        )
    }
}

export default widgetMareting